const SUPPORT_PORTAL_URL = 'https://brkthru.atlassian.net/servicedesk/customer/portal/102';
const REPORT_A_PROBLEM_URL = `${SUPPORT_PORTAL_URL}/group/210/create/11587`;

// Custom field ids on the "Report a problem" request form. The form has no description field, so
// prefill has to target these directly — a param that isn't on the form is dropped silently.
const PAGE_URL_FIELD = 'customfield_11678';
const SUMMARY_FIELD = 'summary';

export function supportPortalUrl() {
  return SUPPORT_PORTAL_URL;
}

export function reportAProblemUrl(summary?: string) {
  const params = new URLSearchParams({ [PAGE_URL_FIELD]: window.location.href });
  // "What happened?" is deliberately left blank — it's where the reporter describes the problem.
  if (summary) params.set(SUMMARY_FIELD, summary);
  return `${REPORT_A_PROBLEM_URL}?${params}`;
}
